const listaDesplegable = (data) => {
  let result = [];

  switch (data) {
    case "ADMIN":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                // {
                //   title: "Inicio",
                //   route: "/inicio",
                // },
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                // {
                //   title: "Mis Cotizaciones Autos",
                //   route: "/mis-cotizaciones",
                // },
                // {
                //   title: "Mis Cotizaciones Celular",
                //   route: "/mis-cotizaciones-celular",
                // },

                {
                  title: "Mis Cotizaciones",
                  route: "/main-hub/4",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
                // {
                //   title: "Cuotas de Pólizas",
                //   route: "/cuotas-hub",
                //   //route: '/proximamente',
                // },
                // {
                //   title: "Mis Comisiones",
                //   route: "/lista-comisiones",
                //   // route: '/proximamente',
                // },

                // {
                //   title: "Mis Productos",
                //   route: "/lista-productos",
                //   //route: '/proximamente',
                // },
                {
                  title: "Chats Leads",
                  route: "/chats-leads",
                },
                {
                  title: "Chats clientes",
                  route: "/chats-clientes",
                },
                {
                  title: "Leads ECI",
                  route: "/leads",
                },
                {
                  title: "Clientes ECI",
                  route: "/clientes-eci",
                },
                {
                  title: "Servicio Inbound ECI",
                  route: "/inbound",
                },
                {
                  title: "Recicle Leads ECI",
                  route: "/leads/recicle-lead",
                },
              ],
            },
            {
              action: "mdi-account-box-multiple-outline",
              title: "Administración",
              items: [
                {
                  title: "Admin de Prospectos",
                  route: "/lista/prospectos",
                  //route: '/proximamente',
                },
                {
                  title: "Admin de Asesores Digitales",
                  route: "/usuarios/agentes",
                  //route: '/proximamente',
                },
                {
                  title: "Admin de Alianzas Corporativas",
                  route: "/administracion/alianzas",
                },
                {
                  title: "Admin de Usuarios",
                  route: "/usuarios",
                  //route: '/proximamente',
                },
                {
                  title: "Admin de campañas",
                  route: "/campaings/table",
                  //route: '/proximamente',
                },
                {
                  title: "Admin de Scripts",
                  route: "/administacion/scripts",
                },
                {
                  title: "Admin de correos",
                  route: "/emails/table",
                  //route: '/proximamente',
                },
                {
                  title: "Administrador de plantillas",
                  route: "/administacion/plantillas",
                },
                {
                  title: "Admin Disposiciones Outbound Ventas",
                  route: "/administacion/disposiciones_outbound",
                },
                {
                  title: "Admin asistencias y beneficios",
                  route: "/administracion/asistencias-beneficios",
                },
                {
                  title: "Administración de Productos de Alianzas",
                  route: "/administracion/productos-alianzas",
                },
                {
                  title: "Administración de Envió Certificado Onbording",
                  route: "/administracion/certificado-onboarding",
                },
                {
                  title: "Administración de Validación Telefonica",
                  route: "/administracion/phone-validation",
                },
                {
                  title: "Carga de Emisiones Betterware",
                  route: "/administracion/carga-emisiones-betterware"
                },
                  {
                  title: "Carga de Emisiones Alianzas",
                  route: "/administracion/carga-emisiones-alianzas",
                },
                {
                  title: "Carga de Facturacion Alianzas",
                  route: "/administracion/carga-facturacion-alianzas",
                },
                {
                  title: "Admin alianzas inter.mx",
                  route: "/administracion/alianzas-intermx",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                {
                  title: "SLA de Solicitudes",
                  route: "/sla-solicitudes",
                },
                {
                  title: "Solicitudes con Pólizas",
                  route: "/solicitudes-con-polizas",
                },
                {
                  title: "Solicitudes Pendientes de Aprobación",
                  route: "/solicitudes-pendientes-aprobacion",
                },
                {
                  title: "Cartera de Agentes",
                  route: "/cartera-agentes",
                },
                {
                  title: "Cartera de Clientes",
                  route: "/proximamente",
                },
                {
                  title: "Reporte de Pólizas",
                  route: "/reporte/emisiones",
                },
                {
                  title: "Reporte Pólizas Autos Masivos (Anterior)",
                  route: "/callcenter/reporte-emisiones-offline",
                },
                {
                  title: "Reporte Pólizas Emitidas (Anterior)",
                  route: "/polizas-emitidas",
                },
                {
                  title: "Pólizas por renovar",
                  route: "/polizas-por-renovar",
                },
                {
                  title: "Pólizas renovadas",
                  route: "/polizas-renovadas",
                },
                {
                  title: "Cuotas de Pólizas Activas",
                  route: "/cobranza-polizas-activas",
                },
                {
                  title: "Reporte de pago de comisiones aplicados",
                  route: "/reporte-pago-comisiones-aplicados",
                },
                {
                  title: "Reporte dispersión de cuotas a asesores",
                  route: "/reporte-dispercion-asesores",
                },
                {
                  title: "Reporte de pagos",
                  route: "/reporte/pagos",
                },
                {
                  title: "Reporte de solicitudes",
                  route: "/reporte/solicitudes",
                },
                {
                  title: "Reporte de beneficiarios",
                  route: "/reporte/beneficiarios",
                },
                {
                  title: "Reporte de redención de beneficios",
                  route: "/reporte/redencion-beneficios",
                },
                // {
                //   title: 'Pólizas con cobranza Vencida',
                //   route: '/proximamente',
                // },
                // {
                //   title: 'Cuotas Pagadas',
                //   route: '/cuotas-pagadas',
                // },
                {
                  title: "Cuotas Canceladas",
                  route: "/cuotas-canceladas",
                },
                {
                  title: "Cuotas Vencidas",
                  route: "/cuotas-vencidas",
                },
                {
                  title: "Comisiones pendientes de Pago de la Aseguradora",
                  route: "/proximamente",
                },
                {
                  title: "Comisiones Pendiente de Pago al agente",
                  route: "/proximamente",
                },
                {
                  title: "Comisiones Pagadas al Agente",
                  route: "/proximamente",
                },
                {
                  title: "Atracción de talento",
                  route: "/atraccion-talento",
                },
                {
                  title: "Reporte de emisiones alianzas",
                  route: "/reporte-emisiones-alianzas",
                },
                {
                  title: "Reporte de solicitudes alianzas",
                  route: "/reporte-solicitudes-alianzas",
                },
                {
                  title: "Reporte de pagos",
                  route: "/reporte-pagos-alianzas",
                },
                {
                  title: "Reporte de familiares/beneficiarios",
                  route: "/reporte-familiares-beneficiarios",
                },
                {
                  title: "Reporte Redencion",
                  route: "/reporte-redencion-alianza",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-search",
              title: "Reportes ECI",
              items: [
                {
                  title: "Reportes leads",
                  route: "/reporte/leads",
                },
                {
                  title: "Reporte Call Back Time",
                  route: "/reporte/call-back-time",
                },
                {
                  title: "Reporte de Marcación de Leads",
                  route: "/reporte/marcacion",
                },
                {
                  title: "Reporte de Cotizaciones Landings",
                  route: "/administrador/reporte-clientes",
                },
                {
                  title: "Reporte de Abandono ECI Landing",
                  route: "/landings/reporteAbandonoLeads",
                },
                {
                  title: "Reporte de Tarificación Comparador",
                  route: "/reporte-tarificacion",
                },
                {
                  title: "Reporte de Marcación",
                  route: "/reporte/marcacion",
                },
                {
                  title: "Reporte de Marcación Simple",
                  route: "/reporte/marcacion-simple",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes PosVenta",
              items: [
                // {
                //   title: "Solicitudes Inbound",
                //   route: "/reporte/solicitudes-inbound",
                // },
                {
                  title: "Solicitudes Emails",
                  route: "/reporte/solicitudes-email",
                },
                {
                  title: "Llamadas inbound",
                  route: "/reporte/llamadas-inbound",
                },
                {
                  title: "Solicitudes Post-Venta",
                  route: "/reporte/solicitudes-postventa",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "GERENTEALIANZA":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
              ],
            },
            {
              action: "mdi-account-box-multiple-outline",
              title: "Administración",
              items: [
                {
                  title: "Admin de Usuarios",
                  route: "/usuarios",
                  //route: '/proximamente',
                },
                {
                  title: "Admin asistencias y beneficios",
                  route: "/administracion/asistencias-beneficios",
                },
                {
                  title: "Administración de Productos de Alianzas",
                  route: "/administracion/productos-alianzas",
                },
                {
                  title: "Administración de Envió Certificado Onbording",
                  route: "/administracion/certificado-onboarding",
                },
                {
                  title: "Administración de Validación Telefonica",
                  route: "/administracion/phone-validation",
                },
                {
                  title: "Carga de Emisiones Betterware",
                  route: "/administracion/carga-emisiones-betterware"
                },
                  {
                  title: "Carga de Emisiones Alianzas",
                  route: "/administracion/carga-emisiones-alianzas"
                },
                {
                  title: "Carga de Facturacion Alianzas",
                  route: "/administracion/carga-facturacion-alianzas",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                {
                  title: "Reporte de emisiones alianzas",
                  route: "/reporte-emisiones-alianzas",
                },
                {
                  title: "Reporte de solicitudes alianzas",
                  route: "/reporte-solicitudes-alianzas",
                },
                {
                  title: "Reporte de pagos",
                  route: "/reporte-pagos-alianzas",
                },
                {
                  title: "Reporte de familiares/beneficiarios",
                  route: "/reporte-familiares-beneficiarios",
                },
                {
                  title: "Reporte Redencion",
                  route: "/reporte-redencion-alianza",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "AGENTCCALIANZAS":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                },
                {
                  title: "Leads ECI",
                  route: "/leads",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "VALIDADORCCALIANZAS":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                },
                {
                  title: "Leads ECI",
                  route: "/leads",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "ADMINCCALIANZAS":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                },
                {
                  title: "Leads ECI",
                  route: "/leads",
                },
                {
                  title: "Servicio Inbound ECI",
                  route: "/inbound",
                },
                {
                  title: "Recicle Leads ECI",
                  route: "/leads/recicle-lead",
                },
              ],
            },
          ],
        },
        {
          action: "mdi-account-box-multiple-outline",
          title: "Administración",
          items: [
            {
              title: "Admin de Usuarios",
              route: "/usuarios",
            },
            {
              title: "Admin de campañas",
              route: "/campaings/table",
            },
            // {
            //   title: "Admin de scripts",
            //   route: "/campaings/table",
            // },
          ],
        },
        {
          action: "mdi-clipboard-text-search",
          title: "Reportes ECI",
          items: [
            {
              title: "Reportes leads",
              route: "/reporte/leads",
            },
            {
              title: "Reporte Call Back Time",
              route: "/reporte/call-back-time",
            },
            {
              title: "Reporte de Marcación de Leads",
              route: "/reporte/marcacion",
            },
            {
              title: "Reporte de Cotizaciones Landings",
              route: "/administrador/reporte-clientes",
            },
            {
              title: "Reporte de Abandono ECI Landing",
              route: "/landings/reporteAbandonoLeads",
            },
            {
              title: "Reporte de Tarificación Comparador",
              route: "/reporte-tarificacion",
            },
            {
              title: "Reporte de Marcación",
              route: "/reporte/marcacion",
            },
            {
              title: "Reporte de Marcación Simple",
              route: "/reporte/marcacion-simple",
            },
            {
              title: "Reporte de Pólizas",
              route: "/reporte/emisiones",
            },
          ],
        },
      ];
      break;
    case "MANAGERCCALIANZAS":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                },
                {
                  title: "Leads ECI",
                  route: "/leads",
                },
                {
                  title: "Servicio Inbound ECI",
                  route: "/inbound",
                },
                {
                  title: "Recicle Leads ECI",
                  route: "/leads/recicle-lead",
                },
              ],
            },
          ],
        },
        {
          action: "mdi-account-box-multiple-outline",
          title: "Administración",
          items: [
            {
              title: "Admin de Usuarios",
              route: "/usuarios",
            },
          ],
        },
        {
          action: "mdi-clipboard-text-search",
          title: "Reportes ECI",
          items: [
            {
              title: "Reportes leads",
              route: "/reporte/leads",
            },
            {
              title: "Reporte Call Back Time",
              route: "/reporte/call-back-time",
            },
            {
              title: "Reporte de Marcación de Leads",
              route: "/reporte/marcacion",
            },
            {
              title: "Reporte de Cotizaciones Landings",
              route: "/administrador/reporte-clientes",
            },
            {
              title: "Reporte de Abandono ECI Landing",
              route: "/landings/reporteAbandonoLeads",
            },
            {
              title: "Reporte de Tarificación Comparador",
              route: "/reporte-tarificacion",
            },
            {
              title: "Reporte de Marcación",
              route: "/reporte/marcacion",
            },
            {
              title: "Reporte de Marcación Simple",
              route: "/reporte/marcacion-simple",
            },
            {
              title: "Reporte de Pólizas",
              route: "/reporte/emisiones",
            },
          ],
        },
      ];
      break;
    case "ADMINALIANZA":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
              ],
            },
            {
              action: "mdi-account-box-multiple-outline",
              title: "Administración",
              items: [
                {
                  title: "Admin de Usuarios",
                  route: "/usuarios",
                  //route: '/proximamente',
                },
                {
                  title: "Admin asistencias y beneficios",
                  route: "/administracion/asistencias-beneficios",
                },
                {
                  title: "Administración de Productos de Alianzas",
                  route: "/administracion/productos-alianzas",
                },
                {
                  title: "Administración de Envió Certificado Onbording",
                  route: "/administracion/certificado-onboarding",
                },
                {
                  title: "Administración de Validación Telefonica",
                  route: "/administracion/phone-validation",
                },
                {
                  title: "Carga de Emisiones Betterware",
                  route: "/administracion/carga-emisiones-betterware"
                },
                  {
                  title: "Carga de Emisiones Alianzas",
                  route: "/administracion/carga-emisiones-alianzas",
                },
                {
                  title: "Carga de Facturacion Alianzas",
                  route: "/administracion/carga-facturacion-alianzas",
                },
                // {
                //   title: "Admin de Scripts",
                //   route: "/administacion/scripts",
                // },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                {
                  title: "Reporte de emisiones alianzas",
                  route: "/reporte-emisiones-alianzas",
                },
                {
                  title: "Reporte de solicitudes alianzas",
                  route: "/reporte-solicitudes-alianzas",
                },
                {
                  title: "Reporte de pagos",
                  route: "/reporte-pagos-alianzas",
                },
                {
                  title: "Reporte de familiares/beneficiarios",
                  route: "/reporte-familiares-beneficiarios",
                },
                {
                  title: "Reporte Redencion",
                  route: "/reporte-redencion-alianza",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "COORDINADORALIANZA":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
              ],
            },
            {
              action: "mdi-account-box-multiple-outline",
              title: "Administración",
              items: [
                {
                  title: "Admin de Usuarios",
                  route: "/usuarios",
                  //route: '/proximamente',
                },
                {
                  title: "Admin asistencias y beneficios",
                  route: "/administracion/asistencias-beneficios",
                },
                {
                  title: "Administración de Productos de Alianzas",
                  route: "/administracion/productos-alianzas",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                {
                  title: "Reporte de emisiones alianzas",
                  route: "/reporte-emisiones-alianzas",
                },
                {
                  title: "Reporte de familiares/beneficiarios",
                  route: "/reporte-familiares-beneficiarios",
                },
                // {
                //   title: "Reporte de Solicitudes",
                //   route: "/reporte/solicitudes",
                // },
                // {
                //   title: "Reporte de Beneficiarios (Proximamente)",
                //   // route: "/reporte/beneficiarios",
                //   route: '/proximamente',

                // },
                {
                  title: "Reporte de pagos",
                  route: "/reporte-pagos-alianzas",
                },
                {
                  title: "Reporte Redencion",
                  route: "/reporte-redencion-alianza",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "SUPERVISORALIANZA":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
              ],
            },
            {
              action: "mdi-account-box-multiple-outline",
              title: "Administración",
              items: [
                {
                  title: "Admin de Usuarios",
                  route: "/usuarios",
                  //route: '/proximamente',
                },
                {
                  title: "Admin asistencias y beneficios",
                  route: "/administracion/asistencias-beneficios",
                },
                {
                  title: "Administración de Productos de Alianzas",
                  route: "/administracion/productos-alianzas",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                // {
                //   title: "Reporte de Solicitudes",
                //   route: "/reporte/solicitudes",
                //  },
                //  {
                //   title: "Reporte de emisiones alianzas",
                //   route: "/reporte-emisiones-alianzas",
                //  },
                {
                  title: "Reporte Redencion",
                  route: "/reporte-redencion-alianza",
                },
              ],
            },
          ],
        },
      ];
      break;
    case "OPERADORSERVICIOSALIANZA":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
              ],
            },
             {
              action: "mdi-account-box-multiple-outline",
              title: "Administración",
              items: [
                {
                  title: "Carga de Emisiones Betterware",
                  route: "/administracion/carga-emisiones-betterware"
                },
                {
                  title: "Carga de Emisiones Alianzas",
                  route: "/administracion/carga-emisiones-alianzas",
                },
                {
                  title: "Carga de Facturacion Alianzas",
                  route: "/administracion/carga-facturacion-alianzas",
                },
              ],
            },
          ],
        },
       
      ];
      break;
      case "EJECUTIVOGABSSA":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
                {
                  title: "Mis Solicitudes",
                  route: "/main-hub/1",
                  //route: '/proximamente',
                },
                /*
                {
                  title: "Mis Pólizas",
                  route: "/main-hub/2",
                  //route: '/proximamente',
                },
                {
                  title: "Mis Clientes",
                  route: "/main-hub/3",
                  //route: '/proximamente',
                },
                */
              ],
            },
          ],
        },
      ];
      break;
    case "ASEGURADORAALIANZAS":
    case "ASISTENCIADORAALIANZAS":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                {
                  title: "Reporte de emisiones alianzas",
                  route: "/reporte-emisiones-alianzas",
                },
                {
                  title: "Reporte de solicitudes alianzas",
                  route: "/reporte-solicitudes-alianzas",
                },
                // {
                //   title: "Reporte de Beneficiarios (Proximamente)",
                //   // route: "/reporte/beneficiarios",
                //   route: '/proximamente',

                // },
              ],
            },
          ],
        },
      ];
      break;
    case "WORKFORCE":
      result = [
        {
          title: "Inicio",
          items: [
            {
              action: "mdi-account-circle",
              active: true,
              title: "Mi espacio",
              items: [
                {
                  title: "Mi perfil",
                  route: "/usuario/ver-micuenta",
                },
              ],
            },
            {
              action: "mdi-clipboard-text-multiple",
              title: "Reportes",
              items: [
                {
                  title: "Reporte de emisiones alianzas",
                  route: "/reporte-emisiones-alianzas",
                },
              ],
            },
          ],
        },
      ];
  }
  return result;
};

module.exports = listaDesplegable;
